// extracted by mini-css-extract-plugin
export default {"containerLayout":"styles_containerLayout__U-BI6"};